import { FieldStateV3 } from './FormStateV3';
import { action, observable } from 'mobx';

export class SingleSelectWithFreeAnswerFieldState extends FieldStateV3<string> {
    @observable normalValue = '';
    @observable freeAnswerChecked = false;
    @observable freeAnswerValue = '';

    constructor(validators) {
        super(validators);
    }

    @action.bound
    setNormalValue(nextValue) {
        this.normalValue = nextValue;
        this.freeAnswerValue = '';
        this.freeAnswerChecked = false;
        this.syncValue();
    }
    @action.bound
    setFreeAnswerValue(nextValue: string) {
        this.normalValue = '';
        this.freeAnswerValue = nextValue;
        this.freeAnswerChecked = true;
        this.syncValue();
    }
    @action.bound
    setFreeAnswerChecked(nextValue: boolean) {
        this.freeAnswerChecked = nextValue;
        if (nextValue) {
            this.normalValue = '';
        }
        this.syncValue();
    }
    @action.bound
    private syncValue() {
        this.setDirtyValue(this.freeAnswerValue || this.normalValue);
    }
}
